import { FC } from 'react';
import { useForm } from 'react-hook-form';

import { LocaleForm } from '../../../components/Layout/Footer/LocaleForm';
import { UserPreferences } from '../../../context/UserPreferencesContext';
import { useCountryCode } from '../../../hooks/useCountryCode';
import { useCurrency } from '../../../hooks/useCurrency';
import { useUnitOfMeasurement } from '../../../hooks/useUnitOfMeasurement';
import { useFlow } from '../../../providers';

export const LocaleStep: FC = () => {
  const { goToStep } = useFlow();
  const [currency] = useCurrency();
  const [unit] = useUnitOfMeasurement();
  const [countryCode] = useCountryCode();

  const form = useForm<Omit<UserPreferences, 'cookieConsent'>>({
    defaultValues: {
      countryCode,
      currency,
      unitOfMeasurement: unit,
    },
  });

  return <LocaleForm form={form} hideForm={() => goToStep('apply')} />;
};
